export const DELIVERY_TYPES = ['EMAIL', 'FTP', 'SFTP', 'FTPS'];
